<div class="feedback-item">
    <div class="colored-bubble">
        <core-helpers-icons-colored-bubble-circle-letter [title]="feedback.user.name"
            [color]="getBubbleColor(feedback)"></core-helpers-icons-colored-bubble-circle-letter>
    </div>
    <!-- old status  <span class="feedback-status" [style.background-color]="getApprovalColor(feedback.status.status_code)">{{feedback.status.status_text}}</span> -->
    <span class="feedback-status">{{feedback.approval != null ? feedback.approval.status_text : 'Comments'}}</span>
    <span class="feedback-info">by <strong>{{feedback.user.name}}</strong>
        <span *ngIf="feedback.approval != null else feedbackDate" > on {{feedback.approval.date | date: 'dd MMM yyyy'}}  at {{feedback.approval.date | date:'HH:mm'}}</span>
        <ng-template #feedbackDate>
            <span > on {{feedback.status.date | date: 'dd MMM yyyy'}}  at {{feedback.status.date | date:'HH:mm'}}</span>

        </ng-template>
    </span>
    <!-- put the core component -->
    <core-helpers-navigation-three-dots-menu [menu]="menu"
        (action)="onApprovalMenuSelect($event)"></core-helpers-navigation-three-dots-menu>
</div>

